module.exports = __webpack_public_path__ + "public/img/芒果@1x.08fa06f8.png";